import View from './view';
import ErrorPopup from '../error';
import Log from '../../util/log';

export default class Presenter {
  constructor(model, config, removeLoader) {
    this.model = model;
    this.config = config;
    this.removeLoader = removeLoader;
    this.hashSetup = false;
  }

  onAttach() {
    if (this.config && !this.hashSetup) {
      this.setup();
      this.hashSetup = true;
    }
  }

  update(hash, config) {
    this.model.hash = hash;
    this.model.config = config;
    this.config = config;
    if (this.config && !this.hashSetup) {
      this.setup();
      this.hashSetup = true;
    }
  }

  onLogin(notificationType) {
    this.model.values = {
      notificationType,
      index: View.Page.link,
    };
  }

  onContinueClick() {
    this.model.showMobileOnly = false;
  }

  setup() {
    const {
      environment,
      version,
      key,
      domain,
      ga_tracking_id: ga,
      login,
      campaign,
      debug,
      error: errorConfig,
      facebook_app_id: facebook,
      google_app_id: google,
      outside_app_id: outside,
      session_bypass: sessionBypass,
      signup_bypass: signupBypass,
    } = this.config;

    const { hostname } = window.location;
    if (domain && hostname !== domain) {
      const url = `https://${domain}${window.location.pathname}${window.location.hash}${window.location.search}`;
      window.location.replace(url);
      return;
    }

    const { delay: errorDelay, redirect_on_load: redirectOnLoadError } = errorConfig;
    if (login?.redirect?.length > 0) {
      window.location.href = login.redirect;
      return;
    }
    // allow testing of error screen, this should be disabled for prod
    if (debug?.show_error?.code) {
      ErrorPopup.show(debug.show_error.code, () => {});
    }

    VlabsUser.init({
      key,
      config: {
        environment,
        version,
        ga,
        campaign,
        facebook_app: facebook,
        google_app: google,
        outside_app: outside,
        session_bypass: sessionBypass,
        signup_bypass: signupBypass,
      },
    });

    VlabsUser.load(
      () => {
        const { email, phone } = VlabsUser.query || {};
        this.model.initialToken = email || phone;
        this.removeLoader?.();
        this.removeLoader = null;
      },
      () => {
        this.model.index = View.Page.link;
        this.removeLoader?.();
        this.removeLoader = null;
      },
      (error) => {
        ErrorPopup.show(error, () => {}, redirectOnLoadError && errorDelay);
        this.removeLoader?.();
        this.removeLoader = null;
        Log.error(error);
      }
    );
  }
}
